<template>
  <div
    class="xsou-pc-footer-container"
    :style="{ backgroundColor: backgroundColor }"
  >
    <footer class="xsou-pc-footer">
      <div class="xsou-footer-divider"></div>
      <div class="xsou-footer-content">
        <div class="xsou-footer-left">
          <div class="xsou-footer-logo">
            <img
              :src="footerLogoSrc"
              :alt="footerLogoAlt"
              :class="{ 'festival-footer-logo': activeDoodle }"
            />
          </div>
          <div class="xsou-social-icons">
            <!-- 电子邮箱 -->
            <img
              :src="require('@/assets/pc/pc-email.png')"
              :alt="$t('pcFooter.email')"
            />
            <!-- 电话 -->
            <img
              :src="require('@/assets/pc/pc-phone.png')"
              :alt="$t('pcFooter.phone')"
            />
            <!-- 微信 -->
            <img
              :src="require('@/assets/pc/pc-wechat.png')"
              :alt="$t('pcFooter.wechat')"
            />
            <!-- 微博 -->
            <img
              :src="require('@/assets/pc/pc-weibo.png')"
              :alt="$t('pcFooter.weibo')"
            />
            <!-- 淘宝 -->
            <img
              :src="require('@/assets/pc/pc-taobao.png')"
              :alt="$t('pcFooter.taobao')"
            />
          </div>
          <!-- Copyright © 2017-2026 先搜科技 (https://www.xsou.com) All Rights Reserved. -->
          <div class="xsou-copyright">
            {{ $t("pcFooter.copyright") }}
          </div>
          <a class="xsou-icp" target="_blank" href="https://beian.miit.gov.cn">
            粤ICP备18129742号
          </a>
        </div>
        <div class="xsou-footer-right">
          <div class="xsou-footer-column">
            <!-- 先搜科技 -->
            <div class="xsou-column-title">{{ $t("pcFooter.company") }}</div>
            <!-- 关于先搜 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goAbout('about_xsou')"
              >{{ $t("pcFooter.about") }}</a
            >
            <!-- 联系我们 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goAbout('contact')"
              >{{ $t("pcFooter.contact") }}</a
            >
            <!-- 加入我们 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goAbout('join')"
              >{{ $t("pcFooter.join") }}</a
            >
            <!-- 隐私说明 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goAbout('privacy')"
              >{{ $t("pcFooter.privacy") }}</a
            >
            <!-- 帮助中心 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goAbout('help')"
              >{{ $t("pcFooter.help") }}</a
            >
          </div>
          <div class="xsou-footer-column">
            <!-- 先搜服务 -->
            <div class="xsou-column-title">{{ $t("pcFooter.services") }}</div>
            <!-- 供应商入驻 -->
            <a
              href="#"
              class="xsou-column-link xsou-column-link--disabled"
              @click.prevent
              >{{ $t("pcFooter.supplierJoin") }}</a
            >
            <!-- 供应链管理 -->
            <a
              href="#"
              class="xsou-column-link xsou-column-link--disabled"
              @click.prevent
              >{{ $t("pcFooter.supplyChainManagement") }}</a
            >
            <!-- 供应链服务 -->
            <a
              href="#"
              class="xsou-column-link xsou-column-link--disabled"
              @click.prevent
              >{{ $t("pcFooter.supplyChainServices") }}</a
            >
            <!-- 供应链金融 -->
            <a
              href="#"
              class="xsou-column-link xsou-column-link--disabled"
              @click.prevent
              >{{ $t("pcFooter.supplyChainFinance") }}</a
            >
          </div>
          <div class="xsou-footer-column">
            <!-- 产品介绍 -->
            <div class="xsou-column-title">{{ $t("pcFooter.products") }}</div>
            <!-- 闪存 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goProduct('flash')"
              >{{ $t("pcFooter.flash") }}</a
            >
            <!-- 内存 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goProduct('memory')"
              >{{ $t("pcFooter.memory") }}</a
            >
            <!-- 嵌入式存储器 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goProduct('embedded')"
              >{{ $t("pcFooter.embedded") }}</a
            >
            <!-- 固态硬盘 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goProduct('ssd')"
              >{{ $t("pcFooter.ssd") }}</a
            >
            <!-- 内存条 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goProduct('memory-module')"
              >{{ $t("pcFooter.memoryModule") }}</a
            >
            <!-- USB闪存卡 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goProduct('usb-flash-card')"
              >{{ $t("pcFooter.usbFlashCard") }}</a
            >
            <!-- GPU服务器 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="goProduct('server')"
              >{{ $t("pcFooter.gpuServer") }}</a
            >
          </div>
          <div class="xsou-footer-column">
            <!-- 先搜芯链 -->
            <div class="xsou-column-title">
              {{ $t("pcFooter.chipNetwork") }}
            </div>
            <!-- 先搜AI -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="go('/pc/myAi')"
              >{{ $t("pcFooter.ai") }}</a
            >
            <!-- 芯片精选 -->
            <a href="/pc/home" class="xsou-column-link">{{
              $t("pcFooter.featuredChips")
            }}</a>
            <!-- 芯片竞价 -->
            <a
              href="#"
              class="xsou-column-link"
              @click.prevent="go('/pc/bid')"
              >{{ $t("pcFooter.bidding") }}</a
            >
            <!-- 供需信息 -->
            <a
              href="#"
              class="xsou-column-link xsou-column-link--disabled"
              @click.prevent
              >{{ $t("pcFooter.supplyDemand") }}</a
            >
            <!-- 芯片自营 -->
            <a
              href="#"
              class="xsou-column-link xsou-column-link--disabled"
              @click.prevent
              >{{ $t("pcFooter.directSales") }}</a
            >
            <!-- 芯片百科 -->
            <a
              href="#"
              class="xsou-column-link xsou-column-link--disabled"
              @click.prevent
              >{{ $t("pcFooter.wiki") }}</a
            >
            <!-- 价格指数 -->
            <a
              href="#"
              class="xsou-column-link xsou-column-link--disabled"
              @click.prevent
              >{{ $t("pcFooter.marketIndex") }}</a
            >
          </div>
          <div class="xsou-footer-column">
            <!-- 工具 -->
            <div class="xsou-column-title">{{ $t("pcFooter.tools") }}</div>
            <!-- ASC工具 -->
            <a
              href="https://www.xsou.com/plugs/asc.html"
              class="xsou-column-link"
              >{{ $t("pcFooter.ascTool") }}</a
            >
            <!-- XML工具 -->
            <a
              href="https://www.xsou.com/plugs/xml-tool.html"
              class="xsou-column-link"
              >{{ $t("pcFooter.xmlTool") }}</a
            >
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { resolveHomeDoodle } from "@/indexlogo/schedule";

export default {
  name: "PcFooter",
  props: {
    backgroundColor: {
      type: String,
      default: "#f8f8f8",
    },
  },
  data() {
    return { activeDoodle: null, doodleTimer: null };
  },
  computed: {
    footerLogoSrc() {
      return this.activeDoodle?.navImage || require("@/assets/pc/pc-slogo.png");
    },
    footerLogoAlt() {
      return this.activeDoodle
        ? `先搜${this.activeDoodle.name}页脚标志`
        : "logo";
    },
  },
  created() {
    this.refreshDoodle();
    this.doodleTimer = window.setInterval(this.refreshDoodle, 10 * 1000);
  },
  beforeDestroy() {
    window.clearInterval(this.doodleTimer);
  },
  methods: {
    refreshDoodle() {
      this.activeDoodle = resolveHomeDoodle(
        new Date(),
        this.$route.query.doodle || "",
      );
    },
    go(path) {
      if (this.$route.path === path) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      this.$router.push(path).catch(() => {});
    },
    goAbout(section) {
      // 页脚沿用当前关于页的query定位方式，后台编辑内容仍由同一个页面读取。
      this.$router
        .push({
          path: "/pc/about",
          query: { section },
        })
        .catch(() => {});
    },
    goProduct(product) {
      this.$router
        .push({
          path: "/pc/products",
          query: { product },
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.xsou-pc-footer-container {
  width: 100%;
  background-color: #f8f8f8;
}
.xsou-pc-footer {
  width: 1480px;
  margin: 0 auto;
  padding: 24px 0 48px;
  color: #333;
}

.xsou-footer-divider {
  width: 100%;
  margin: 0 auto 36px;
  border-top: 1px solid #a3a3a3;
}

.xsou-footer-content {
  width: min(1900px, calc(100% - 120px));
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  gap: 80px;
}

.xsou-footer-left {
  min-width: 620px;
}

.xsou-footer-logo {
  width: 107px;
  margin-bottom: 20px;
}

.xsou-footer-logo img {
  width: 100%;
  display: block;
}
.xsou-footer-logo img.festival-footer-logo {
  width: auto;
  max-width: 230px;
  max-height: 62px;
  object-fit: contain;
}

.xsou-social-icons {
  display: flex;
  align-items: center;
  gap: 22px;
  margin-bottom: 24px;
}

.xsou-social-icons img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.xsou-copyright,
.xsou-icp {
  display: block;
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  text-decoration: none;
}

.xsou-footer-right {
  display: flex;
  justify-content: flex-end;
  gap: 64px;
}

.xsou-footer-column {
  min-width: 88px;
  display: flex;
  flex-direction: column;
}

.xsou-column-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.xsou-column-link {
  font-size: 16px;
  color: #666;
  margin-bottom: 12px;
  text-decoration: none;
  transition: color 0.3s;
  cursor: pointer;
}

.xsou-column-link:hover {
  color: #1890ff;
}

.xsou-column-link--disabled,
.xsou-column-link--disabled:hover {
  color: #c8c8c8;
  cursor: default;
}

.xsou-column-link:last-child {
  margin-bottom: 0;
}

@media (max-width: 1200px) {
  .xsou-footer-content {
    flex-direction: column;
  }

  .xsou-footer-left {
    min-width: 0;
  }

  .xsou-footer-right {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}

@media (max-width: 700px) {
  .xsou-footer-right {
    display: none;
  }
}
</style>
